export enum QuestionFormatTypes {
  ToUpper = 0,
  ToInitialCharacterCapitalized = 1
}
